import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class CaseEnquiryService {
    private apiUrl = `${environment.apiUrl}/api/case-inquiries`;

    constructor(private http: HttpClient, private authService: AuthService) { }

    createEnquiry(enquiry: any): Observable<any> {
        return this.http.post<any>(this.apiUrl, enquiry);
    }

    getEnquiries(): Observable<any[]> {
        const role = this.authService.getRole();
        let params = new HttpParams();
        if (role) {
            params = params.set('role', role);
        }
        return this.http.get<any[]>(this.apiUrl, { params });
    }

    getAcceptedEnquiries(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/accepted`);
    }

    getEnquiryById(caseId: number | string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/${caseId}`);
    }

    updateEnquiryStatus(id: number, status: string, notes: string): Observable<any> {
        const payload = { review_notes: notes };
        return this.http.patch<any>(`${this.apiUrl}/${id}/${status}`, payload);
    }
}
